module.exports = __webpack_public_path__ + "media/src/img/vk-icon-blue-becaac8addfadfcb9f1b7f91a40b4da1.svg";